import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[policy-func]'
})
export class PolicyFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}